import { render, staticRenderFns } from "./AuthPasswordResetFrom.vue?vue&type=template&id=d03663ba&scoped=true&lang=pug&"
import script from "./AuthPasswordResetFrom.vue?vue&type=script&lang=js&"
export * from "./AuthPasswordResetFrom.vue?vue&type=script&lang=js&"
import style0 from "./AuthPasswordResetFrom.vue?vue&type=style&index=0&id=d03663ba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d03663ba",
  null
  
)

export default component.exports